import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { User } from '@marageti/z4-sdk/lib/auth';
import { useSnackbar } from 'notistack';
import View from './profile-view';

const Container = () => {
  const { agentId } = useParams();
  const apiClient = useApiClient();
  const { enqueueSnackbar } = useSnackbar();
  const { data: agent, mutate: mutateAgent } = useFetch<Agent>(apiClient.peopleClient.getAgent, [agentId], !!agentId);
  const { mutate: mutateUser } = useFetch<User>(apiClient.authClient.getUser, [agent?.userInfo[0].id], true);
  const [editorOpen, setEditorOpen] = useState(false);
  const [emailEditorOpen, setEmailEditorOpen] = useState(false);

  const handleCloseEditor = () => {
    mutateAgent();
    mutateUser();
    setEditorOpen(false);
    setEmailEditorOpen(false);
  };

  const handleOpenEditor = () => setEditorOpen(true);
  const handleOpenEmailEditor = () => setEmailEditorOpen(true);

  const editContextMenu = {
    id: 'agent-profile-context-menu',
    items: [{
      label: 'Edit Profile',
      action: handleOpenEditor,
    },
    {
      label: 'Edit Email Address',
      action: handleOpenEmailEditor,
    }],
  };

  const handleEditAvatar = async (avatar: string) => {
    if (agent) {
      try {
        const { avatar: updatedAvatar } = await apiClient.peopleClient.putAgentAvatar(agent.id, {
          id: agent.id,
          avatar,
        });
        mutateAgent({ ...agent, avatar: updatedAvatar }, { revalidate: false });
      } catch (error) {
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      }
    }
  };
  return (
    <View
      agent={agent}
      contextMenuProps={editContextMenu}
      editorOpen={editorOpen}
      emailEditorOpen={emailEditorOpen}
      onCloseEditor={handleCloseEditor}
      onEditAvatar={handleEditAvatar}
    />
  );
};

export default Container;
